/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import compose from 'lodash/fp/compose';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

import { withNamespaces } from 'react-i18next';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import { Container, Row, Column } from '../../../styles/Grid';
import * as styles from './index.styles';
import defaultsDeep from 'lodash/defaultsDeep';
import get from 'lodash/get';

import Card from './Card';
import Spacer from '../../ui/Spacer';

const defaultData = {
  ProductSitemaps: { value: [] },
};
export class CTARow extends SafePureComponent {
  constructor(props) {
    super(props);
    this.fields = defaultsDeep(props.rendering.fields, defaultData);
  }

  lowerFirstLetter = string => {
    return string.charAt(0).toLowerCase() + string.slice(1);
  };

  getColumnWidth = cardCount => {
    if (cardCount === 4) {
      return { xs: 12, sm: 6, md: 4, lg: 4, xl: 2 };
    }
    if (cardCount === 5) {
      return { xs: 12, sm: 6, md: 4, lg: 4, xl: 2 };
    }
    return { xs: 12, sm: 6, md: 4, lg: 4, xl: 2 };
  };

  renderCard = () => {
    let items = get(this.fields, 'items', []);
    let LocationInformation = get(this.fields, 'LocationInformation', {});
    // icon.value.src = 'http://regus.dev.local/' + icon.value.src;
    let tempLocationInformation = { ...LocationInformation };
    for (const keyInfo in LocationInformation) {
      tempLocationInformation[this.lowerFirstLetter(keyInfo)] =
        LocationInformation[keyInfo];
    }

    // items = items.filter((val, index) => index < 4);

    const ColumnWidth = this.getColumnWidth(items.length);
    return (
      <Row css={[styles.card_component_top]}>
        {items.map(function (item, index) {
          const ctaClassHeading = get(item, 'fields.Heading.value', '')
            .split(' ')
            .join('');

          return (
            <Column
              css={styles.cust_grid}
              cols={ColumnWidth}
              key={index}
              className={`div-ctalist-${ctaClassHeading}`}
            >
              <Card
                item={item}
                LocationInformation={tempLocationInformation}
                ctaClassHeading={ctaClassHeading}
              />
            </Column>
          );
        })}
      </Row>
    );
  };

  safeRender() {
    return (
      <Spacer
        customCss={[styles.hiddenspace]}
        paddingCss={styles.containerPaddingCss}
      >
        <Container>{this.renderCard()}</Container>
      </Spacer>
    );
  }
}

CTARow.displayName = 'CTARow';

export default compose(withNamespaces(), withSitecoreContext())(CTARow);
